import { AccessData, Landing, Webinar } from '@anm/api/modules/hosting';
import Checkbox from '@anm/components/form/Checkbox';
import InputPassword from '@anm/components/form/InputPassword';
import SectionTitle from '@anm/components/video-landings/SectionTitle';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { LoaderWrapper } from '../../hosting/CustomizationSection';
import { landingsSelectors } from '../../../store/modules/landings';

import useWebinarAccess from './hooks/useWebinarAccess';
import { Label, Wrapper } from './styles';
import useWebinarPageElements from './hooks/useWebinarPageElements';

export type AccessTabProps = {
  webinar: Landing;
  access: AccessData;
};

const AccessTab: FC<AccessTabProps> = props => {
  const [nameEmail, password, isPassword, updatePassword, onNameEmailSelect, onPasswordSelect] = useWebinarAccess(
    props
  );

  const [showOnDemand, onShowOnDemandToggle] = useWebinarPageElements(props.webinar as Webinar);

  return (
    <Wrapper>
      <SectionTitle title="Access settings" level={2} />
      <Label>
        <Checkbox checked={nameEmail} onChange={onNameEmailSelect} />
        <p>Name and email are required</p>
      </Label>
      <Label>
        <Checkbox checked={isPassword} onChange={onPasswordSelect} />
        <p>Password is required</p>
      </Label>
      <InputPassword onChange={updatePassword} value={password || ''} disabled={!isPassword} />
      <Label>
        <Checkbox checked={showOnDemand} onChange={onShowOnDemandToggle} />
        <p>Webinar is available after it has ended</p>
      </Label>
      {/* {canShowCommentsOnDemand && isChat && (
        <Label>
          <Checkbox checked={showCommentsOnDemand} onChange={onShowCommentsOnDemandToggle} />
          <p>Show chat after webinar is over</p>
        </Label>
      )} */}
    </Wrapper>
  );
};

const AccessTabWrapper: FC = () => {
  const webinar = useSelector(landingsSelectors.selectLanding) as Webinar;

  if (!webinar || !webinar.parameters.access) return <LoaderWrapper size="large" color="blue" />;

  return <AccessTab webinar={webinar} access={webinar.parameters.access} />;
};

export default AccessTabWrapper;
